"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ACADEMIC: 'ACADEMIC',
    BOOKING: 'BOOKING',
    CONTRACT: 'CONTRACT',
    LESSON: 'LESSON',
    FEEDBACK: 'FEEDBACK',
    USER: 'USER',
    CALENDAR: 'CALENDAR',
    WARNING: 'WARNING',
    REPORT: 'REPORT',
    ROADMAP: 'ROADMAP',
};
//# sourceMappingURL=inAppMessage.js.map